export default __webpack_public_path__ + "static/media/refer.51aad851.jpg";